const growthCentreToId = growthCentre => (growthCentre ? growthCentre._id : 'all')

export default growthCentreToId
